import React, { useState } from 'react';
import Select from 'react-select';
import { useCsvPerformanceStore } from './store';
import { useQueryGetUsers } from '../../../query/user';
import useDebounce from '../../../hooks/useDebounce';
import UserWithAvatar from '../../../components/ui/UserWithAvatar';

const UserFilterOptions = ({ innerProps, data }) => {
  return (
    <div className="react-select__option" {...innerProps}>
      <UserWithAvatar
        textStyle={{
          fontSize: 10,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        user={data}
        wrapperStyle={{ width: '100%', padding: '5px 5px' }}
      />
    </div>
  );
};

const LabelRender = ({ innerProps, data }) => {
  return (
    <div {...innerProps} style={{ overflow: 'hidden', padding: 2 }}>
      <p className="text-ellipsis" style={{ marginBottom: 0, fontSize: 10 }}>
        {data.fullName || data.userName || data.email}
      </p>
    </div>
  );
};

export default function UserFilter() {
  const { selectedUsers, setSelectedUsers } = useCsvPerformanceStore();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );
  const { data = [], isFetching } = useQueryGetUsers({
    search: debouncedSearch,
  });
  return (
    <Select
      classNamePrefix="react-select-small"
      components={{ Option: UserFilterOptions, MultiValueLabel: LabelRender }}
      filterOption={() => true}
      isClearable={false}
      isLoading={isFetching}
      isMulti
      isSearchable
      menuPortalTarget={document.body}
      options={data.map(e => ({
        ...e,
        label: e.fullName,
        value: e.id,
      }))}
      placeholder="Filter by owners..."
      styles={{ fontSize: 10 }}
      value={selectedUsers.map(e => ({
        ...e,
        label: e.fullName,
        value: e.id,
      }))}
      onChange={setSelectedUsers}
      onInputChange={value => setSearch(value)}
    />
  );
}
